import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewFiltersModel } from '../../../allocation-view/models';
import {
  AllocationViewFilterProfileDto,
  AllocationViewFilterProfileModel,
  mapAllocationViewFilterProfileRequest,
  mapAllocationViewFilterProfileResponse,
  mapAllocationViewFiltersRequest,
} from '../../models';
import { AllocationViewProfilesEndpoint } from './../../constants';
@Injectable({
  providedIn: 'root',
})
export class AllocationViewFilterProfileItemService {
  private readonly filterProfileKey = 'allocation-view-filter-profile';
  private readonly profileFilterUrl = `${API_URL}${AllocationViewProfilesEndpoint.FilterProfiles}`;

  constructor(private http: WrapperHttpService) {}

  setFilterProfile(item: AllocationViewFilterProfileModel): void {
    localStorage.setItem(this.filterProfileKey, JSON.stringify(item));
  }

  getSelectedFilterProfile(): AllocationViewFilterProfileModel {
    const filterProfileJson = localStorage.getItem(this.filterProfileKey);
    return JSON.parse(filterProfileJson) || null;
  }

  createFilterProfile(name: string, filters: AllocationViewFiltersModel): Observable<AllocationViewFilterProfileModel> {
    const request: AllocationViewFilterProfileDto = {
      name,
      filters: mapAllocationViewFiltersRequest(filters),
    };

    return this.http
      .withLoading()
      .post<AllocationViewFilterProfileDto | void>(this.profileFilterUrl, request)
      .pipe(
        map((dto: AllocationViewFilterProfileDto | void) =>
          mapAllocationViewFilterProfileResponse(dto ? dto : request),
        ),
      );
  }

  updateFilterProfile(item: AllocationViewFilterProfileModel): Observable<AllocationViewFilterProfileModel> {
    const request = mapAllocationViewFilterProfileRequest(item);

    return this.http
      .withLoading()
      .put<AllocationViewFilterProfileDto | void>(this.profileFilterUrl, request)
      .pipe(
        map((dto: AllocationViewFilterProfileDto | void) =>
          mapAllocationViewFilterProfileResponse(dto ? dto : request),
        ),
      );
  }

  getFilterProfileById(id: number): Observable<AllocationViewFilterProfileModel> {
    return this.http
      .withLoading()
      .get<AllocationViewFilterProfileDto>(`${this.profileFilterUrl}/${id}`)
      .pipe(map(mapAllocationViewFilterProfileResponse));
  }

  deleteFilterProfile(id: number): Observable<void> {
    return this.http.withLoading().delete<void>(`${this.profileFilterUrl}/${id}`);
  }
}
